import React from 'react'
import StaticPage from '../components/StaticPage'

function SafetyPage() {
  return (
    <StaticPage title="Safety Guidelines" intro="Fly safe in the Borders">
      <p>
        Paragliding is inherently dangerous. These notes are a friendly reminder, not a substitute
        for proper training, a current rating, and your own judgement on the day.
      </p>

      <h2>Before you fly</h2>
      <ul>
        <li>Check the forecast and the actual conditions on the hill. If in doubt, don't.</li>
        <li>Read the site guide for the site you're flying, including wind directions and hazards.</li>
        <li>Check NOTAMs and any airspace or low-flying restrictions for the area.</li>
        <li>Make sure your equipment is airworthy and your reserve is in date.</li>
      </ul>

      <h2>Respect the sites</h2>
      <ul>
        <li>Our access depends on good relations with farmers and landowners. Park sensibly and never block gateways or tracks.</li>
        <li>Do not fly during lambing season (typically late March to late May) where noted on a site.</li>
        <li>Follow any site-specific restrictions - some sites are sensitive and have rules on times and areas.</li>
        <li>Leave gates as you find them and take your litter home.</li>
      </ul>

      <h2>Fly within your limits</h2>
      <p>
        Only fly sites and conditions appropriate to your rating and experience. If you're new to a
        site, fly with someone who knows it. When in doubt, <a href="/contact">ask the club</a>.
      </p>

      <p className="muted">Always check weather conditions and fly within your limits.</p>
    </StaticPage>
  )
}

export default SafetyPage
